//css class for cetering and format text to bold
export const CENTER_TEXT_BOLD = "d-flex justify-content-center font-weight-bold";
export const JUSTIFY_CENTER = "d-flex justify-content-center";
